import React from 'react';

export function FbShare({ width, height, color }) {
  return <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox="0 0 24 24">
    <defs>
        <path id="f" d="M8.917 21.5v-8.498H6V9.625h2.917V6.953c0-1.41.404-2.505 1.212-3.284.808-.78 1.881-1.169 3.22-1.169 1.085 0 1.97.05 2.651.148v3.006h-1.818c-.682 0-1.15.149-1.402.446-.202.247-.303.643-.303 1.187v2.338h3.22l-.455 3.377h-2.765V21.5h-3.56z"/>
    </defs>
    <use fill={color} fillRule="evenodd" xlinkHref="#f"/>
  </svg>;
}